/* PRISMAX — lightweight localStorage wishlist.
   Any [data-wish="<handle>"] button toggles + reflects saved state site-wide. */
(function () {
  var KEY = 'prismax-wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function has(h) { return get().indexOf(h) > -1; }
  function setBtn(b, on) {
    b.classList.toggle('on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.innerHTML = b.innerHTML.replace(/[♡♥]/, on ? '♥' : '♡'); // ♡ / ♥
  }
  function paint() {
    document.querySelectorAll('[data-wish]').forEach(function (b) { setBtn(b, has(b.getAttribute('data-wish'))); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wish'); if (!h) return;
    var a = get(), i = a.indexOf(h), on;
    if (i > -1) { a.splice(i, 1); on = false; } else { a.push(h); on = true; }
    save(a);
    document.querySelectorAll('[data-wish="' + h + '"]').forEach(function (el) { setBtn(el, on); });
    if (window.PrismaxCart && window.PrismaxCart.toast) window.PrismaxCart.toast(on ? 'Saved to wishlist' : 'Removed from wishlist');
  });
  if (document.readyState !== 'loading') paint();
  else document.addEventListener('DOMContentLoaded', paint);
  window.PrismaxWishlist = { get: get, has: has };
})();
